import React, { useState } from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import { StaticTimePicker } from '@mui/x-date-pickers';
import { useTranslation } from 'react-i18next';

import { useComposer, useDelivery } from '../../../../../hooks/index';
import { DateProvider } from '../../../../../Providers/index';
import { DateWrapper } from '../../../../../Components/index';
import { getPickerProps, DateInput } from './Date/index';

const isValid = date => dayjs(date, 'HH:mm').isValid();

const TimeComposer = props => {
  const [open, setOpen] = useState(false);

  const { t } = useTranslation('bots');

  const { reply, setReply } = useComposer();

  const { sendMessage } = useDelivery();

  const handleChange = date => {
    setReply(dayjs(date).format('HH:mm'));
  };

  const handleInputClick = () => setOpen(open => !open);

  const handleSend = () => {
    if (isValid(reply)) {
      sendMessage(reply);
      setOpen(false);
      setReply('');
    }
  };

  return (
    <DateProvider>
      <DateWrapper>
        {open && (
          <StaticTimePicker
            localeText={{ timePickerToolbarTitle: '' }}
            margin="dense"
            minutesStep={5}
            onAccept={date => {
              handleChange(date);
              setOpen(false);
            }}
            onChange={handleChange}
            slotProps={{
              actionBar: {
                actions: [],
              },
            }}
            value={reply
              ? dayjs(reply, 'HH:mm')
              : null}
            {
            ...getPickerProps(
              props.variant, {
              open,
              setOpen,
              handleChange
            }
            )
            }
          />
        )}
        <DateInput
          placeholder={t('time_composer_label')}
          aria-label={t('time_composer_label')}
          value={reply}
          onClick={handleInputClick}
          handleSubmit={handleSend}
        />
      </DateWrapper>
    </DateProvider>
  );
};

TimeComposer.propTypes = {
  variant: PropTypes.oneOf(['dialog', 'static'])
};

export default TimeComposer;
